// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768px","card":"FirstVetCard_card__dc6NI","imgContainer":"FirstVetCard_imgContainer__gtZo1"};